import {
  createMasonryEngineInstance,
  type MasonryEngineNodeQueryParams,
} from '@leagueplatform/masonry-engine';
import { createAsyncNode } from '@leagueplatform/masonry-api';
import React from 'react';
import { driver } from './masonry-engine/masonry-driver/driver';
import { useStableQueryParams } from './utils/use-stable-query-params';

export const createMasonryInstance = () => {
  const masonryEngineInstance = createMasonryEngineInstance(driver);

  const Component = ({
    rootNodeId,
    initialQueryParams,
  }: {
    rootNodeId: string;
    initialQueryParams?: MasonryEngineNodeQueryParams;
  }) => {
    const stableParams = useStableQueryParams(initialQueryParams);
    const rootNode = React.useMemo(
      () =>
        createAsyncNode({
          id: rootNodeId,
          initialQueryParams: stableParams,
        }),
      [stableParams, rootNodeId],
    );

    return <masonryEngineInstance.Component rootNode={rootNode} />;
  };

  Component.displayName = 'MasonryInstance';

  return {
    ...masonryEngineInstance,
    Component,
  };
};
